// frontend/src/components/MultiSelect.jsx
// Extracted from VendorList.jsx — was file-local, now shared (also used by GroupManagement.jsx).
export default function MultiSelect({
  label,
  options,
  selected,
  onChange,
  getLabel,
  getValue,
}) {
  const count = selected.length;
  return (
    <div className="flex flex-col gap-1 min-w-[160px]">
      <label className="text-xs text-gray-500 font-medium">
        {label}
        {count > 0 && <span className="ml-1 text-brand-600">({count})</span>}
      </label>
      <details className="group relative">
        <summary className="flex items-center justify-between w-full px-3 py-2 border border-gray-300 rounded-lg bg-white cursor-pointer hover:bg-gray-50 list-none text-sm text-gray-700">
          <span>{count === 0 ? `All ${label}s` : `${count} selected`}</span>
          <svg
            className="w-4 h-4 text-gray-400 group-open:rotate-180 transition-transform flex-shrink-0 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <div className="absolute z-20 mt-1 w-full min-w-[200px] bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-y-auto">
          {options.length === 0 ? (
            <p className="px-3 py-2 text-sm text-gray-400 italic">
              No options available
            </p>
          ) : (
            options.map((opt) => {
              const val = getValue ? getValue(opt) : opt.id;
              const lbl = getLabel ? getLabel(opt) : opt.name;
              const checked = selected.includes(val);
              return (
                <label
                  key={val}
                  className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() =>
                      onChange(
                        checked
                          ? selected.filter((v) => v !== val)
                          : [...selected, val],
                      )
                    }
                    className="rounded border-gray-300 text-brand-500 focus:ring-brand-500"
                  />
                  <span className="text-sm text-gray-700">{lbl}</span>
                </label>
              );
            })
          )}
        </div>
      </details>
    </div>
  );
}
